import { FC } from 'react'
import { SvgProps } from '@/components/atoms/svg/svgProps'

const UserIconTowerRedesign: FC<SvgProps> = ({ width, height, color }) => (
  <svg
    id="icon-user-space"
    viewBox="0 0 512 512"
    width={width || 24}
    height={height || 24}
    fill={color || '#000'}
  >
    <path d="M510.7 438.7c-2.3-10.8-12.8-17.8-23.7-15.5-10.8 2.3-17.8 12.8-15.5 23.7 1.3 6.2-.2 12.6-4.2 17.5-2.3 2.8-7.5 7.6-16 7.6H60.7c-8.5 0-13.7-4.8-16-7.6-4-4.9-5.5-11.3-4.2-17.5 20.8-99.7 108.7-172.5 210.2-175 1.8.1 3.5.1 5.3.1 1.8 0 3.6 0 5.3-.1 71.5 1.7 137.6 37.9 177.7 97.7 6.2 9.2 18.6 11.6 27.8 5.5 9.2-6.2 11.6-18.6 5.5-27.7-32.8-48.9-80.5-84.5-134.8-102.4 33-25 54.5-64.5 54.5-109C392 61 331 0 256 0S120 61 120 136c0 44.5 21.5 84.1 54.6 108.9-30.4 10-58.9 25.6-83.8 46.1-45.7 37.6-77.5 90.1-89.5 147.7-3.8 18.1.7 36.6 12.4 50.9 11.6 14.2 28.7 22.4 47 22.4h390.6c18.3 0 35.5-8.2 47-22.4 11.7-14.3 16.2-32.8 12.4-50.9ZM160 136c0-52.9 43.1-96 96-96s96 43.1 96 96c0 51.3-40.5 93.3-91.1 95.9h-9.7c-50.7-2.5-91.2-44.6-91.2-95.9Z" />
  </svg>
)

export default UserIconTowerRedesign
